import React from 'react'
import { Link } from '@elements'
import Imgix from 'react-imgix'

export const Cards = ({
  cards,
  cardsAddImageToHeadline,
  cardsHeadline,
  overlapBottom,
  overlapTop,
  cardsHeadlineImage,
}) => {
  return (
    <section className="bg-gray-200">
      <div className={`container transform ${overlapTop && `-translate-y-16`}`}>
        {cardsHeadline && (
          <div className="flex flex-col items-center justify-between py-10 lg:flex-row lg:py-16">
            <h1 className="font-sans text-4xl font-bold leading-tight tracking-wider text-center uppercase sm:text-5xl text-brand-red">
              {cardsHeadline}
            </h1>
            {cardsAddImageToHeadline === 'Yes' && (
              <Imgix
                src={cardsHeadlineImage.mediaItemUrl}
                alt={cardsHeadlineImage.altText}
                className="max-w-xs mt-8 mr-4 lg:mt-0"
              />
            )}
          </div>
        )}
        <div className="flex flex-wrap md:-mx-8 md:justify-center">
          {/* For card layouts with 2 cards, keep them small and centered */}
          {cards.length < 3 &&
            cards.map((card, idx) => (
              <div
                key={idx}
                className="w-full max-w-sm mx-auto mt-4 md:w-1/2 sm:max-w-md md:mx-0 md:px-4"
              >
                <div className="w-full p-10 leading-tight text-gray-400 bg-gray-100 shadow-md md:h-full">
                  <h2 className="font-sans text-4xl font-bold tracking-wider uppercase sm:text-5xl">
                    {card.cardTitle}
                  </h2>
                  <p className="mt-2 text-lg leading-normal sm:mt-4 sm:text-2xl sm:leading-snug">
                    {card.cardContent}
                  </p>
                  {card.callToActionGroup.ctaLinkUrl && (
                    <Link
                      to={card.callToActionGroup.ctaLinkUrl}
                      className={
                        card.callToActionGroup.ctaButtonType === `primary`
                          ? `inline-block mt-12 px-10 pt-1 font-sans text-2xl font-bold text-gray-400 no-underline uppercase transition duration-200 border-6 border-brand-yellow hover:bg-brand-yellow`
                          : card.callToActionGroup.ctaButtonType === `text`
                          ? `inline-block mt-12 ml-2 font-sans text-xl font-bold tracking-wide text-gray-400 no-underline uppercase transition duration-200 border-b-4 border-gray-400 sm:mt-16 sm:border-b-6 hover:border-brand-yellow sm:text-2xl`
                          : ``
                      }
                    >
                      {card.callToActionGroup.ctaLinkText}
                    </Link>
                  )}
                </div>
              </div>
            ))}
          {/* For card layouts with more than 2 cards, let them be a full grid */}
          {cards.length > 3 &&
            cards.map((card, idx) => (
              <div
                key={idx}
                className="w-full mx-auto mt-4 lg md:w-1/2 md:px-4 lg:px-8 lg:pb-12"
              >
                <div className="w-full p-10 leading-tight text-gray-400 bg-white shadow-md lg:p-16 md:h-full">
                  <h2 className="font-sans text-4xl font-bold tracking-wider text-black uppercase sm:text-5xl">
                    {card.cardTitle}
                  </h2>
                  <p className="mt-2 text-lg leading-normal sm:mt-4 sm:text-2xl sm:leading-snug">
                    {card.cardContent}
                  </p>
                  {card.callToActionGroup.ctaLinkUrl && (
                    <Link
                      to={card.callToActionGroup.ctaLinkUrl}
                      className={
                        card.callToActionGroup.ctaButtonType === `primary`
                          ? `inline-block mt-12 px-10 pt-1 font-sans text-2xl font-bold text-gray-400 no-underline uppercase transition duration-200 border-6 border-brand-yellow hover:bg-brand-yellow`
                          : card.callToActionGroup.ctaButtonType === `text`
                          ? `inline-block mt-12 ml-2 font-sans text-xl font-bold tracking-wide text-gray-400 no-underline uppercase transition duration-200 border-b-4 border-gray-400 sm:mt-16 sm:border-b-6 hover:border-brand-yellow sm:text-2xl`
                          : ``
                      }
                    >
                      {card.callToActionGroup.ctaLinkText}
                    </Link>
                  )}
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  )
}
